import gsap from 'gsap';
import { ScrambleTextPlugin } from './util/ScrambleTextPlugin.min.js';
gsap.registerPlugin(ScrambleTextPlugin);

const init = (isRM) => {
  if (isRM) return;

  let isHover = false;

  gsap.matchMedia().add(
    {
      hasHover: '(hover: none)'
    },
    (ctx) => {
      isHover = ctx.conditions.hasHover;
    }
  );

  if (isHover) return;

  const followContainerNode = document.querySelector('.mouse-follow-container');
  const followerNode = document.querySelector('.mouse-follower');
  const followerTextNode = document.querySelector('.mouse-text-follower');

  const xTo = gsap.quickTo('body', '--follower-x', {
    duration: 0.333,
    ease: 'power3'
  });
  const yTo = gsap.quickTo('body', '--follower-y', {
    duration: 0.333,
    ease: 'power3'
  });

  const followWrappers = document.querySelectorAll('.follower-wrapper');

  const revertFollower = function () {
    this.removeEventListener('mouseleave', revertFollower);

    gsap.timeline().to(followerNode, {
      height: '10px',
      width: '10px',
      backgroundColor: '#fde541'
    });
    gsap.set(followContainerNode, {
      mixBlendMode: 'difference'
    });

    gsap.to(followerTextNode, {
      scrambleText: {
        chars: '10',
        revealDelay: 0.2,
        text: ''
      }
    });

    this.addEventListener('mouseover', addNewFollower);
  };

  const addNewFollower = function () {
    this.removeEventListener('mouseover', addNewFollower);
    const followerSize = this.dataset.followerSize || '138px';

    gsap.set(followContainerNode, {
      mixBlendMode: this.classList.contains('follower-wrapper--color-burn')
        ? 'color-burn'
        : 'multiply'
    });

    gsap.to(followerTextNode, {
      scrambleText: {
        chars: '10',
        text: this.dataset.followText,
        revealDelay: 0.1
      }
    });

    gsap.to(followerNode, {
      height: followerSize,
      width: followerSize,
      backgroundColor: '#174acb'
    });

    this.addEventListener('mouseleave', revertFollower);
  };

  followWrappers.forEach((el) => {
    el.addEventListener('mouseover', addNewFollower);
  });

  window.addEventListener('mousemove', (e) => {
    xTo(e.clientX);
    yTo(e.clientY);
  });
};

export { init };
